const Form001EN = {
    stepName: {
        ImportantNotes: "Important Notes",
        ApplicationInfo: "Application Information",
        Declaration: "Declaration",
        Confirmation: "Confirmation",
    },
    headBar: {
        bar1: "Copies of HKID card / Student card of Applicant and Family Members",
        bar2: "PART A PERSONAL DATA OF APPLICANT",
        bar3: "PART B INFORMATION ON APPLICANT's FAMILY",
        bar4: "TABLE 1  FAMILY MEMBERS</br><b>Section A: Applicant and applicant's parents or spouse </b>(For retired parents, please also complete Table 2. For married applicants, parents' information should be entered in Table 3 only.)",
        bar4Sub1:
            "Annual Income during the Financial Year {{ssaPeriodForm}} – {{ssaPeriodTo}}",
        bar4Sub2:
            "Please provide income proofs of all family members in Sections A and refer to para. 2.2.4 to 2.2.7 of Part II of the Guidance Notes for details.",
        bar5: "Section B: Applicant's UNMARRIED brothers and sisters residing with applicant and/or applicant's parent(s) between {{ssaPeriodForm}} and {{ssaPeriodTo}}",
        bar5Sub1:
            " (for married applicant, his/her children residing with the applicant)",
        bar5Sub2:
            "Please provide income proofs of all family members in Sections B and refer to para. 2.2.4 to 2.2.7 of Part II of the Guidance Notes for details.",
        bar6: "Section C: Applicant's UNMARRIED siblings who was a full-time student studying abroad (including those studying in the Mainland or overseas) between {{ssaPeriodForm}} and {{ssaPeriodTo}}",
        bar7: "<b>Section D:  Applicant's grandparents (excluding non-Hong Kong residents) who depended on applicant's parent(s) between {{ssaPeriodForm}} and {{ssaPeriodTo}}</b> (Please refer to para.2.2.3 of Part II of the Guidance Notes)",
        bar8: "TABLE 2 ADDITIONAL INFORMATION ON RETIRED PARENTS OF THE APPLICANT",
        bar9: "TABLE 3 APPLICANT'S OTHER FAMILY MEMBERS – Applicant's sibling(s) living away from applicant and/or applicant's parent(s) (including those living in the Mainland or overseas) and/or any other persons residing with applicant and/or applicant's parent(s) but not included in Table 1",
        bar10: "TABLE 4 ASSETS (including those in Hong Kong and outside Hong Kong which are wholly or partly owned by family member(s) listed in Section A under Table 1 of this application form) ",
        // bar10Sub1:
        //     "(Please do not omit any information. Use additional sheets if required. All documentary proofs have to be submitted together with the application form.)",
        bar11: "(A) Property / Land / Carpark (including those in Hong Kong and outside Hong Kong; including those vacant, rented out or self-occupied.) ",
        bar11Sub1:
            "(Please provide documentary proofs and refer to para. 2.5.5 to 2.5.9 of Part II of the Guidance Notes for details)",
        bar12: "(B) Vehicle / Vessel and/or Taxi / Public Light Bus Licence ",
        bar12Sub1:
            "(including those in Hong Kong and outside Hong Kong irrespective of whether the business undertakings is making profit or not.)",
        bar12Sub2:
            "(Please provide documentary proofs, such as mortgage repayment schedule for vehicle and Vehicle Registration Document, and refer to para. 2.5.10 of Part II of the Guidance Notes for details)",
        bar13: "(C) Business Undertakings",
        bar13Sub1:
            " (including those in Hong Kong and outside Hong Kong irrespective of whether the business undertakings is making profit or not.)",
        bar13Sub2:
            " (Please provide documentary proofs such as Business Registration Certificate, Balance Sheet, Profit and Loss Account, and Annual Statement and refer to para. 2.5.11 and 2.5.12 of Part II of the Guidance Notes for details)",
        bar14: "(D) Investments",
        bar14Sub1:
            "(1) Investment account(s) (including margin account(s)) possessed as at {{ssaPeriodTo}} in bank / securities company and the value of investment items (securities (shares / warrants, etc.) / bonds / funds, etc.) / the cash balance of the account(s) (Please provide relevant supporting documents)",
        bar15: "(2) Physical shares / warrants, etc., possessed as at {{ssaPeriodTo}} (Please provide relevant supporting documents to certify the quantity of investment owned)",
        bar16: "(E) Bank Deposits (including savings / time / current / club deposits / integrated accounts in local and foreign currencies)",
        bar16Sub1:
            " (Please refer to para. 2.5.14 to 2.5.16 of Part II of the Guidance Notes for details)",
        bar17: "(F) Loan lent to Others on or before {{ssaPeriodTo}} (balance as at {{ssaPeriodTo}})",
        bar17Sub1:
            " (including the amounts due to directors) <b>(please refer to para. 2.5.17 of Part II of the Guidance Notes for details)</b>",
        bar18: "(G) Insurance Policy",
        bar18Sub1:
            "<b>(Savings / Investment-linked insurance policy(ies) with cash value and dividends) </br>(Please provide documents which can reflect policy value / dividend as at {{ssaPeriodTo}})</b>",
        bar19: "(H) Others (balance as at {{ssaPeriodTo}})",
        bar20: "TABLE 5 MEDICAL EXPENSES ({{ssaPeriodForm}} – {{ssaPeriodTo}})(Please provide medical proofs and receipts)",
        bar21: "TABLE 6 LENGTH OF RESIDENCE IN HONG KONG",
        bar22: "TABLE 7 ADDITIONAL INFORMATION BY APPLICANT",

        bar23: "(a) By Applicant:",
        bar24: "(b) By Applicant's parents or spouse",
        bar25: "Checklist of Supporting Documents",
    },
    label: {
        titleOption: {
            1: "Mr",
            2: "Miss",
            3: "Ms",
        },
        maritalOption: {
            S: "single",
            M: "married/separated/divorced/widowed",
        },
        isOption: {
            Y: "Yes",
            N: "No",
        },
        relationshipSectionaOption: {
            Applicant: "Applicant",
            Father: "Father",
            Mother: "Mother ",
            Spouse: "Spouse",
        },
        relationshipSectionbOption: {
            Brother: "Brother",
            Sister: "Sister ",
            Children: "Children ",
        },
        relationshipSectioncOption: {
            Brother: "Brother",
            Sister: "Sister ",
        },
        workTimeOption: {
            "Full-time": "Full-time",
            "Part-time": "Part-time",
        },
        sexOption: {
            Male: "Male",
            Female: "Female",
        },
        maritalStuOption: {
            Married: "Married",
            Single: "Single",
        },
        studyYearOption: {
            1: "1",
            2: "2",
            3: "3",
            4: "4",
            5: "5",
            6: "6",
            7: "7",
            8: "8",
            9: "9",
        },
        noOwnerOption: {
            Applicant: "(1) Applicant",
            Father: "(2) Father",
            Mother: "(3) Mother",
            Spouse: "(4) Spouse",
        },
        isHaveOption: {
            have: "have",
            notHave: "do not have",
        },
        codeOption: {
            Applicant: "(1) Applicant",
            Father: "(2) Father",
            Mother: "(3) Mother",
            Spouse: "(4) Spouse",
        },

        approverEmailAddress: "Email address",
        applicantHkidCopy: "Copy of Applicant's HKID card",
        applicantStuCardCopy: "Copy of Applicant's student card",
        fatherHkidCopy:
            "Copy of HKID card of Applicant's father (For married applicant, please provide copy of HKID card of spouse)",
        motherHkidCopy: "Copy of HKID card of Applicant's mother",
        familyStuCardCopy:
            "Copy of HKID card / student card of family member listed below",

        chineseName: "Name in Chinese (if applicable)",
        engSurName: "Surname in English",
        engPersonalName: "First Name in English",
        idCardNo: "Hong Kong Identity Card No.",
        birthMonth: "Date of Birth(MM)",
        birthYear: "Date of Birth(YYYY)",
        title: "Title:",
        maritalStatus: "Marital Status:",
        address: "Residential Address",
        phoneNo: "Residential Phone No.",
        mobileNo: "Mobile Phone No.",

        isAssistance:
            "Did you or your parents/spouse receive Comprehensive Social Security Assistance for the whole period from {{ssaPeriodForm}} to {{ssaPeriodTo}} or are you or your parents/spouse receiving it now?",
        isBusiness:
            "Did your parents run any business between {{ssaPeriodForm}} to {{ssaPeriodTo}}?",
        isAssets:
            "Apart from the self-occupied home, did you or your parents own any other property / land / carpark as at {{ssaPeriodTo}}?",
        fmyMemberNoA: "No. of Family Members (Section A)",
        fmyMemberNoBc: "No. of Family Members (Section B+C)",
        fmyMemberNoD: "No. of Family Members (Section D)",
        annualIncomeA: "Annual Income (Table 1  Section A)",
        annualIncomeB: "Annual Income (Table 1  Section B)",
        fatherIdCardNo: "HKID No. of your father",
        motherIdCardNo: "HKID No. of your mother",

        // Section A
        colCodeNo: "Code No.(CN)",
        colChiName: "Name in Chinese",
        colEngName: "Name in English",
        colAge: "Age",
        colRelationship: "Relationship with Applicant",
        colOccupation:
            "Present Occupation / Employment (state name of post and grade / rank)",
        colMonIncome: "Present Monthly Income",
        colWorkA:
            "Employer / Firm / School<br/>(a) Name / Year of Study (only applicable to students):",
        colWorkB: "Employer / Firm / School<br/>(b) Contact Telephone No.:",
        colWorkC: "Employer / Firm / School<br/>(c) Full / Part-time:",
        colWorkIncome:
            "Salary / Wage / Bonus / Allowance / Part-time income / Commission (not including employee's contribution to MPF / Provident Fund)",
        // colWorkIncomeProofs:
        //     "Income Proofs (Including salary statements, Employer's Return of Employee's Remuneration and Pensions [IR56B], Notification by an employer of an employee who is about to cease to be employed [IR56F], Tax Assessment and Demand Note [IRC6401] and Return of Employee's Remuneration [HKSES/4(2020)]):",
        colBusiProfit: "Business Profit",
        colBusiAccount:
            "Income Proofs (please submit a Profit and Loss account):",
        colPension: "Pension",
        colIncomePro: "Income Proofs:",
        colALLPay:
            "Remittance / Alimony / Contribution / Contribution for mortgage repayment or rentals received",
        colRentalIncome:
            "Rental Income of Property / Land / Carpark / Vehicle / Vessel",
        colOtherIncome: "Other Income (please specify)",
        colApersonsNo: "Total Section A (No. of persons)",
        colIscssa: "Whether receiving CSSA from SWD",
        colCssaFile: "Receipt of CSSA:",
        colAnnualIncome: "Total Annual Income",

        // Section B
        colBpersonsNo: "Total Section B (No. of persons)",

        // Section C
        colStudyPlace: "Place/Country of Study",
        colInstituName: "Name of Institution",
        colCourseName:
            "Course Name and Study Level(e.g. Degree, Master Degree)",
        colStudyYear: "Year of Study",
        colGraduaDate: "Expected  Month and Year of Graduation",
        coldependParents: "Whether dependent on applicant's parents for living",
        colProofs: "Proofs (e.g. remittance advices):",
        colCpersonsNo: "Total Section C (No. of persons)",

        // Section D
        colSex: "Sex",
        colIsWithParent: "Resided with applicant or applicant's parent(s)",
        colIsProvideParent:
            "Resided in premises owned/rented by applicant's parent(s)",
        colSupportPro:
            "Supporting Proof on the dependency (e.g. Tax Assessment and Demand Note of your parents)",
        colIsElderlyHome:
            "Resided in an elderly home AND the expenses were  fully paid by applicant's parents for an aggregate period of six months more",
        colElderlyHomePro:
            "Supporting Proof on the dependency (e.g. Elderly home payment receipts):",
        colIsreceiptCssa:
            "Currently receiving CSSA or in receipt of CSSA between {{ssaPeriodForm}} – {{ssaPeriodTo}}",
        colCssaPro: "Receipt of CSSA:",
        colDpersonsNo: "Section D (No. of persons)",

        // Table 2
        colName: "Name",
        colRetirementDate: "Retirement Date",
        colEmployerName: "Name of Last Employer",
        colEmployerTelNo: "Telephone No. of Last Employer",
        colGratuity: "Lump Sum Gratuity",
        colCurMonPension: "Present Monthly Pension",

        // Table 3
        colMaritalStu: "Married / Single",
        colTelNo: "Telephone No.",
        colOccupa: "Occupation",
        colAnnualAlimony:
            "Annual remittance / alimony / contribution (e.g. family / living expenses / mortgage repayment or rental expenses) to  members in Table 1 above between {{ssaPeriodForm}} and {{ssaPeriodTo}}",

        // Table 5
        colOwnerNo: "Code No. of Owner",
        colNatureIll: "Nature of Incapacity or Chronic Illness",
        colAnnualExp: "Annual Expenses",
        colAnnualExpTotal: "Total Annual Expenses",
        colMedicalPro: "Medical Proofs and Receipts",

        // Table 6
        tabSixTip1: "I,",
        tabSixTip2: "the right of abode in Hong Kong.",
        tabSixTip3:
            "I have resided or have had my home continuously in Hong Kong since the Year",
    },
    label2: {
        codeNo: "Code No. of Owner",
        noOrNameOption: {
            Applicant: "(1) Applicant",
            Father: "(2) Father",
            Mother: "(3) Mother",
            Spouse: "(4) Spouse",
        },
        noOrNameOption1: {
            Applicant: "(1) Applicant",
            Father: "(2) Father",
            Mother: "(3) Mother",
            Spouse: "(4) Spouse",
            Deposits: "Deposits Held in Joint Accounts",
        },
        plc1: "Property",
        plc2: "/ Land / Carpark:",
        plcOption: {
            property: "Property",
            land: "Land",
            carpark: "Carpark",
        },
        plcAddress: "Address of Property / Land / Carpark",
        plcUse: "Use of Property / Land / Carpark (e.g. Self-occupied / Rented-out / Vacant) ",
        purchaseDate: "Date of Purchase",
        occupiedDetail: "If self-occupied, please give details",
        propertyType:
            'Type of property (e.g. domestic, shop, factory, office, "Home Ownership Scheme" flat, "Sandwich Class Housing Scheme" flat, "Tenants Purchase Scheme" flat etc.)',
        landArea: "Area of Land / Saleable Area of Property",
        marketValue: "(a) Estimated Market Value as at {{ssaPeriodTo}}",
        mortgage: "(b) Outstanding Mortgage as at {{ssaPeriodTo}}",
        ownership: "(c) Percentage of Ownership",
        netValue: "Net Value",
        proofsDocument:
            "Documentary Proofs (Please refer to para. 2.5.5 to 2.5.9 of Part II of the Guidance Notes for details)",

        type: "Type",
        registration: "Registration No. (e.g. Vehicle Registration Mark)",
        purchaseDate1: "Purchase Date",
        purchasePrice: "Purchase Price",
        marketValue1:
            "(a) Estimated Market Value of the Vehicle / Vessel and/or Licence as at {{ssaPeriodTo}}",
        proofsDocument1:
            "Documentary Proofs (e.g. mortgage repayment schedule for vehicle and Vehicle Registration Document) (Please refer to para. 2.5.10 of Part II of the Guidance Notes for details)",

        businessName: "Name of Business",
        businessAddress: "Address of Business",
        businessState:
            "State whether the business premises are rented or self-owned",
        businessNature: "Nature of Business (e.g. trading)",
        businessNo: "Business Registration No.",
        assetValue: "(a) Estimated Net Asset Value as at {{ssaPeriodTo}}",
        ownershipC: "(b) Percentage of Ownership",
        businessDocument:
            "Documentary Proofs (e.g. Business Registration Certificate, Balance Sheet, Profit and Loss Account, and Annual Statement) (Please refer to para. 2.5.11 and 2.5.12 of Part II of the Guidance Notes for details)",

        companyName: "Bank / Securities Company Name",
        companyAccount: "Bank / Securities Company Account No.",
        investType: "Types of investment items / Account Cash Balance",
        investTypeTemp: "Type of investment item / Account Cash Balance",
        typeEtc:
            "Securities (shares / warrants, etc.) / Bonds / Funds / Account Cash Balance, etc.",
        investValue:
            "Value of Investment Items / Account Cash Balance  as at {{ssaPeriodTo}} (in HK dollars)",
        supportingDocument: "Supporting Documents",

        physicalCode: "Physical Shares / Warrants Code",
        physicalName: "Physical Shares / Warrants Name",
        quantity: "Quantity",
        investDocument:
            "Supporting Documents to certify the quantity of investment owned",

        codeNoName: "Code No. or Name of Owner",
        financialName: "Name of Bank / Financial Company",
        accountNum: "Account Number",
        payroll: "Payroll account",
        accountType: "Type of Account (e.g. time deposit)",
        currency: "Currency",
        balance:
            "Balance as at {{ssaPeriodTo}} (incl. time deposits with the mature date beyond {{ssaPeriodTo}})",
        codeNoNameOption: {
            Y: "Yes",
            N: "No",
        },

        loanAmount:
            "Amount ($) of loan lent to others on or before {{ssaPeriodTo}} and not yet repaid by borrower",

        companyName1: "Company Name",
        policyCode: "Insurance Policy Code",
        tillValue: "Value till {{ssaPeriodTo}}",
        policyDocument:
            "Documents which can reflect policy value / dividend as at {{ssaPeriodTo}}",

        gold: "Gold (tael/ounce)",
        silver: "Silver (tael/ounce)",
        cash: "Cash",
        assetHeld: "Asset held in trust for others",
        assetEntrust: "Asset entrusted to others ($)",
        assetOther:
            "Other Assets (Such as cheques in transit, betting account balance, and other readily realizable assets and valuables, etc.)",
    },

    label3: {
        submitted: {
            s1: "Please provide additional information in this Table and submit the relevant supporting document(s) if:",
            s2: "- there has been substantial change of your family financial position after {{ssaPeriodTo}};",
            s3: "- there are any special circumstances or information that may not be reflected in previous parts of the application form; or",
            s4: "- you have additional documents / information to be submitted.",
        },

        supportInfo:
            "The following supporting document(s) is/are not yet available (Please put down your name and HK Identity Card number on every page of the documents when you submit the outstanding documents)",
        undertake:
            "I undertake to submit it/them to the Education Bureau (EDB) once available. I understand that if I do not take the initiative to submit the said document(s), the EDB and Student Finance Office of the Working Family and Student Financial Assistance Agency may treat it/them as omission and reject my application.",
        signature: "Signature of Applicant",
        supportDoc: "The relevant supporting document(s)",

        declarationATitle:
            "The Declarant must read the Guidance Notes [{{HKSESOne}}] carefully in completing this Declaration. The Guidance Notes are available at the HKSES website at https://hkses.edb.gov.hk.",
        declarationA: {
            text1: "I, (name)",
            text2: ", have read and fully understood the Guidance Notes on Application for Means-tested Bursary under the Hong Kong Scholarship for Excellence Scheme (HKSES) for the {{schYear}} Academic Year",
            text3: " (Guidance Notes)",
            text4: "and I agree to the terms of, and undertake to abide by the Guidance Notes and such other requirements as specified from time to time by the Government if the Government grants me means-tested bursary under the HKSES. I declare that the information provided in this application for means-tested bursary under the HKSES for the {{schYear}} academic year (which shall include any documents submitted to the Education Bureau (EDB) and the Student Finance Office (SFO) of the Working Family and Student Financial Assistance Agency in support of the application",
            text5: "(my application)",
            text6: "is complete and true to the best of my knowledge. I am aware that the Government will rely, and give consent to the Government relying on the information provided by me to determine the eligibility and the level of means-tested bursary to be offered to me under the HKSES. I also understand that any person who by any deception dishonestly obtains for himself or another any pecuniary advantage shall be guilty of an offence and shall be liable on conviction upon indictment to imprisonment for 10 years under the Theft Ordinance (Chapter 210 of the Laws of Hong Kong).",
            text7: "I further give my consent to any Government Policy Bureaux and Departments or private bodies to release my personal data to the EDB and/or SFO for the purpose of processing this application.",
            text8: "I hereby consent, and confirm that each of the family members and other persons in respect of which personal data or other information",
            text9: "(Information)",
            text10: "is provided in my application (including during the course of consideration of such application) consents, to the Government [including the EDB, SFO and any Government Policy Bureaux and Departments]",
            text11: "(the Government)",
            text12: "and the institution offering the programme in respect of which I am making this application using the Information for any purpose contemplated in paragraph 9 of Part I of the Guidance Notes and any purpose directly related to such purpose.",
            text13: "I also authorise and consent to my institution releasing personal data of which I am the subject of the data held by it to the Government in order for the Government to use such information to process my application (and any other application I may make to the Government) and for any other purpose contemplated in paragraph 9 of Part I of the Guidance Notes and any purpose directly related to such purpose.",
            text14: "I understand that the Government has the right to review my application for means-tested bursary for me and adjust my bursary or withdraw the Government's offer of bursary if necessary. I undertake to refund to the Government any overpayment of bursary made to me upon demand.",
            text15: "I agree to let the Government check and counter-check this application in accordance with paragraph 4.5 in Part I of the Guidance Notes. If I refuse to co-operate, I undertake to refund all the bursary already received by me under my application and any other application I may make to the Government.",
            text16: "I acknowledge that the Government's payment of the bursary shall be subject to my honouring all the obligations, conditions, and covenants set out in my application and the other terms by which I am bound under the HKSES.",
            text17: "I declare that as at the date of this application:-",

            text18: "Declared in Hong Kong.",
            text19: "Attention",
            text20: "In recent years, a number of applicants and their family members, all without previous criminal convictions, have been convicted of Fraud arising from failure to disclose incomes / assets during their application for financial assistance. Applicants are reminded that they must report ALL family incomes and assets and the information provided must be",
            text21: "COMPLETE",
            text22: "and",
            text23: "TRUE",
        },
        name: "Name",
        bankRupt: {
            iamBankrupt:
                "I am not a bankrupt and have not applied for Individual Voluntary Arrangement [i.e. the Court has not approved any repayment proposal by me in my capacity as a debtor on how I will repay my creditors] and I am not aware of any legal proceedings which have been started (or are pending or being threatened) against me for my bankruptcy or for the appointment of a receiver, administrator, administrative receiver, trustee or similar officer over any or all of my assets.",
            iamNotBankrupt:
                "I am a bankrupt; and/or I have applied for Individual Voluntary Arrangement [i.e. the Court is considering or has approved a repayment proposal by me in my capacity as a debtor on how I will repay my creditors] and/or I am aware that legal proceeding(s) has/have been started (or are pending or being threatened) against me for my bankruptcy or for the appointment of a receiver, administrator, administrative receiver, trustee or similar officer over any or all of my assets. I have set out the full details in relation to the above at Table 7 – ADDITIONAL INFORMATION BY APPLICANT.",
        },
        signatureApplicant: "Signature of applicant",
        hkidNo: "HKID No.",
        date: "Date",

        declarationB: {
            fatherText: ", father of the applicant,",
            motherText: ", mother of the applicant,",
            spouseText: ", spouse of the applicant,",
            text1: "fully understand the Guidance Notes on Means-tested Bursary under the Hong Kong Scholarship for Excellence Scheme for the {{schYear}} Academic Year.",
            text2: "declare that the information provided in this application form about",
            text3: "family, including all the supporting documents provided, is complete and true.",
            text4: "aware that the Education Bureau (EDB) and Student Finance Office (SFO) of the Working Family and Student Financial Assistance Agency will rely on the information provided to determine the eligibility and the level of means-tested bursary to be offered to the applicant.",
            text5: "also understand that any person who by any deception dishonestly obtains for himself or another any pecuniary advantage shall be guilty of an offence and shall be liable on conviction upon indictment to imprisonment for 10 years under the Theft Ordinance (Chapter 210 of the Laws of Hong Kong).",
            text6: "further give",
            text7: "consent to any Government Policy Bureaux and Departments or private bodies to release",
            text8: "personal data to the SFO for the purpose of processing this application.",
        },
        applicantFaName: "Name of the applicant's father",
        applicantMoName: "Name of the applicant's mother",
        applicantSpoName: "Name of the applicant's spouse",
        weIOption: {
            We: "We",
            I: "I",
        },
        ourMyOption: {
            our: "our",
            my: "my",
        },
        weAndIOption: {
            weAre: "We are",
            iAm: "I am",
        },
        signMyself: "Signature of the Applicant",
        signFa: "Signature of the applicant's father",
        signMo: "Signature of the applicant's mother",
        signSpo: "Signature of the applicant's spouse",

        checklistDoc: {
            text1: "Before submission of application, please check if you have done the following steps:",
            text2: "Identity Information",
            text3: "Income Information",
            text4: "Asset / Residence Information",
            text5: "Expenses Information",
            text6: "Other Information",
        },
        checklistOption: {
            completeForm:
                "Completed fully all parts of the application form.<span style='color: #b30000'> *</span>",
            prepareCopies:
                "Prepared copies of all relevant supporting documents (please ensure that the information shown on the copies is legible):<span style='color: #b30000'> *</span>",
            supplementary:
                "Provided supplementary information in Table 7 – “Additional Information by Applicant” and prepared the relevant documents.",
            signDeclaration:
                "Signed on the page of declaration with your father and mother or spouse.",
        },

        checkSelect: {
            hkidCard: "Your HKID card;",
            // hkidCard: "Your HKID card;<span style='color: #b30000'> *</span>",
            studentCard:
                "Your student card or other supporting document which can identify your registered full-time student status (if applicable);",
            offerLetter:
                "Your offer letter of admission or bank pay-in slip of tuition fee or any other documents which can identify the course taken;",
            marriedCard:
                "The HKID card(s) of your father and mother (or spouse, if married);",
            familyMem:
                "The HKID card(s) of your sibling(s) / grandparent(s) and the student card(s) of your sibling(s) listed in Sections B, C and D of Table 1. If you cannot obtain the above-mentioned HKID cards, please provide other documents proving the identity of the family member;",
            marryCer: "Your marriage certificate (if married); and",
            childCer: "The HKID card / birth certificate of your child.",
            incomeProof:
                "Income proof of your parents and unmarried sibling(s) residing with you and/or your parent(s) (or your spouse, if you are married) for the period {{ssaPeriodForm}} to {{ssaPeriodTo}} (Sections A and B of Table 1), e.g. salary statement / Employer's Return of Employee's Remuneration and Pensions [IR56B] / Profit & Loss Account or other income proofs (If unemployed, please provide documentary proof, e.g. termination letter, medical proof, proof of looking for jobs, proof of studying full-time courses, etc.).",
            deeds: "Supporting documents for property / land / carpark (Section A of Table 4) such as Sale and Purchase Agreement, Demand for Rates, mortgage repayment schedule, assignments and deeds;",
            tenancy: "Tenancy agreement of public housing unit;",
            vehicle: "Vehicle Registration Document (Section B of Table 4);",
            repayment:
                "Mortgage repayment schedule for vehicle (Section B of Table 4);",
            business:
                "Business Registration Certificate (Section C of Table 4);",
            sheet: "Company's balance sheet (Section C of Table 4);",
            cashBalance:
                "Certificate(s) or monthly statement(s) of {{certificateDate}} showing the types and quantity of investment (including margin) items as at {{ssaPeriodTo}}, e.g. shares / warrants / bonds and funds / investment account cash balance (Section D of Table 4);",
            passbooks:
                "All passbooks and monthly statements of all types of bank deposits (including those closed between {{ssaPeriodForm}} and {{ssaPeriodTo}}) of you and your parents (or your spouse, if you are married) (Section E of Table 4) including the page showing the account holder's name, account number and all pages showing the transactions from {{ssaPeriodForm}} to {{ssaPeriodTo}}.",
            deposit:
                "Certificate(s) / receipt(s) / notice(s) on time deposit(s) showing the balance as at {{ssaPeriodTo}} (Section E of Table 4); and",
            annualState:
                "Annual statement showing the value of savings / investment-linked insurance policy with cash value and dividends as at {{ssaPeriodTo}} (Section G of Table 4).",
            medicalProof:
                "Medical proofs and receipts from {{ssaPeriodForm}} to {{ssaPeriodTo}} for family member(s) with chronic illness / permanent incapacity (Table 5).",
            docProofs:
                "Documentary proofs (from {{ssaPeriodForm}} to the latest date) from the Social Welfare Department for family member(s) who is/are receiving Comprehensive Social Security Assistance, including the Certificate of CSSA Recipients (for Medical Waivers) and notification letter;",
            receipts:
                "Receipts for expenses on dependent grandparent(s) residing in elderly home from {{ssaPeriodForm}} to {{ssaPeriodTo}} (Section D of Table 1); and",
            relevantDoc: "Any other documents relevant to the application.",
        },
    },
    declarationBTips: {
        tip1: "Delete where inapplicable.",
        tip2: "If you are not married, your parent(s) should sign the declaration personally. If you are married, your spouse should sign the declaration personally. Any person (including the applicant and his/her family member) signing the declaration on behalf of applicant / the parent(s) / spouse will not only lead to the application being rejected, but will also constitute an act of forgery, which on conviction, may hold the offender liable for imprisonment for 14 years under the Crimes Ordinance (Chapter 200 of the Laws of Hong Kong).",
    },
    tips: {
        tip1: "If you / your parents / your spouse reside in / own a village house / small house, please specify the storey(s) owned by you / your parents / your spouse and the use of each storey.",
        tip2: "Please indicate the code number(s) of the family member(s) or the name(s) of the relative(s) / friend(s) who live in the premises.",
        tip3: "1 ㎡ approximately equals 10.76 square feet.",
        tip4: "Please provide photocopies of documents and specify the documents in detail in Table 7.",
        tip5: " Such as cheques in transit, betting account balance, and other readily realizable assets and valuables, etc.",
    },
    note: {
        note1: "Please provide your student card copy if you are currently a full-time student.",
        note2: "Please also provide copy of applicant's marriage certificate, as well as HKID card or birth certificate / student card copy of applicant's children.",
        // note3: "Please provide his/her student card copy if the family member is currently a full-time student.",

        note4: "Income proofs include salary statements, Employer's Return of Employee's Remuneration and Pensions [IR56B], Notification by an employer of an employee who is about to cease to be employed [IR56F], Tax Assessment and Demand Note [IRC6401] and Return of Employee's Remuneration [{{HKSESFour}}].",
        note5: "Remittance / Alimony / Contribution received by family members in Table 1 above includes family / living expenses / mortgage repayment / rental expenses and /or other expenses (such as insurance premium and loan repayments) provided by others (e.g. divorced parent, siblings living away from applicant and/or applicant's parent(s), relatives / friends, etc.).",
        note6: 'Please indicate "Yes" or "No" in the Box.',
        note7: "Currently receiving Comprehensive Social Security Assistance (CSSA) or in receipt of CSSA for the whole period from {{ssaPeriodForm}} to {{ssaPeriodTo}} (excluding Old Age Allowance / Disability Allowance). If your family member(s) received CSSA, please provide documentary proofs (from {{ssaPeriodForm}} to the latest date), from Social Welfare Department, including the Certificate of CSSA Recipients (for Medical Waivers) and notification letter.",
        note8: 'If your parents have divorced or you have divorced, please state in Table 7 and provide documentary proofs. If your parents are not residing with your family members, please provide details in Table 7 "Additional Information by Applicant".',
        note9: "Your grandparents might be considered as family member if relevant supporting proof on the dependency, such as Tax Assessment and Demand Note of your parents or elderly home payment receipts, is provided.",
        note10: 'If your residential address cannot be reached by post, please indicate your correspondence address here an put down your residential address in the "Additional Information by Applicant" in Table 7',
        note11: "If the business premise is self-owned, please report it in Section A of Table 4 as well.",
        note12: "Applicant's UNMARRIED brothers and sisters residing with applicant and/or applicant’s parent(s) between 1.4.2021 and 31.3.2022 (for married applicant, his/her children residing with the applicant);",
        note13: "Applicant's UNMARRIED siblings who was a full-time student studying abroad (including those studying in the Mainland or overseas) between 1.4.2021 and 31.3.2022; and",
        note14: "Applicant's grandparents (excluding non-Hong Kong residents) who depended on applicant's parent(s) between 1.4.2021 and 31.3.2022 (Please refer to para. 2.2.3 of Part II of the Guidance Notes)",
    },
    importantCon: {
        con1: 'Only <b>eligible applicants</b> under the {{group}} cohort of the HKSES (i.e. {{schYear}} cohort) for the {{schYear}} academic year <b>who have been shortlisted for further consideration in the selection process</b> and <b>awardees</b> of the HKSES for the previous cohorts are eligible for applying for means-tested bursary under the HKSES. For details of the eligibility criteria of the HKSES, please refer to the HKSES website at <a href="https://hkses.edb.gov.hk" target="_blank" rel="noreferrer">https://hkses.edb.gov.hk.</a>',
        con2: "Only <b>awardees</b> of the HKSES <b>who have passed the means test</b> conducted by the Student Finance Office (SFO) of the Working Family and Student Financial Assistance Agency will receive means-tested bursary under the HKSES.",
        con3: "Applicants must read the <span style='color: blue'>{{guidanceNote}}</span> carefully when completing this form.",
        con4: "This application must be completed <u><b>FULLY and TRUTHFULLY</b></u>. The information supplied by the applicant in this application will be used to determine whether means-tested bursary should be offered to the applicant/awardee under the HKSES and if so, the level of the bursary to be offered.  Any misrepresentation or omission or improperly filling in information in this application form may lead to <b><u>disqualification from application and/or full recovery of the bursary already paid to the applicant/awardee, and court proceedings</b></u>.  Applicants are reminded that it is an offence to obtain property or pecuniary advantage by deception.  Any person who does so commits an offence and shall be liable on conviction upon indictment to imprisonment for 10 years under the Theft Ordinance (Chapter 210 of the Laws of Hong Kong).  Applicants are also reminded that if any person being required or authorised by law to make any statement on oath for any purpose and being lawfully sworn (otherwise than in a judicial proceeding) wilfully makes a statement which is material for that purpose and which he knows to be false or does not believe to be true, he shall be guilty of an offence and shall be liable on conviction upon indictment to imprisonment for 7 years and to a fine under the Crimes Ordinance (Chapter 200 of the Laws of Hong Kong).",
        con5: "<b>If applicants fail to report / provide the required information / supporting document(s) in / to the Application Form at the time of submitting their application, and the information / supporting document(s) is only reported / provided upon the Education Bureau (EDB) / SFO's enquiry, this would be treated as a misrepresentation and/or omission in the application.</b>",
        con6: "Applicants should inform the Education Bureau (EDB) at 7/F, East Wing, Central Government Offices, 2 Tim Mei Avenue, Tamar, Hong Kong in writing <u>immediately</u> of any changes of information in Parts A to B after submission of the application.  Outdated information will cause unnecessary delay in processing of applications.",
        con7: "Only the awardees of the HKSES who have passed the means test conducted by the SFO will receive means-tested bursary under the HKSES.  Every year, the SFO selects a number of awardees receiving the means-tested bursary for counter-checking by home visits, bank search or other means.  Applicants and their family members are requested to co-operate with the SFO's staff.  Intentional obstruction to the SFO's staff in their course of investigation or concealment of information may lead to <u><b>full recovery of the bursary already paid and even court proceedings</b></u>.",
        con8: "If applicants are not married, both of their parents should sign in the part of “Declaration”.  If applicants are married, their spouse should sign in the part of “Declaration”.  Applicants should <b>NOT</b> sign the declaration on behalf of their parents / spouse.  If applicants do so, the application will be <b>REJECTED</b>.  Applicants are reminded that a person who makes a false instrument, with the intention that he or another shall use it to induce somebody to accept it as genuine, and by reason of so accepting it to do or not to do some act to his own or any other person's prejudice, commits the offence of forgery and is liable on conviction on indictment to imprisonment for 14 years under the Crimes Ordinance (Chapter 200 of the Laws of Hong Kong).",
        con9: "Applications should be submitted online via the application system <b>on or before {{applicationDate}}</b>. In general, if the information provided by applicants is complete, they will be notified of the application result within about one to two months from the date of acknowledging receipt of their applications. The earlier the applicants submit a complete set of applications and supporting documents, the earlier they will be notified of the application result. Late submission of supporting documents may defer the application result. </br></br> If the information provided is incomplete or inconsistent, the SFO will require applicants to clarify the discrepancy or provide supplementary information.  This will result in prolonged processing time of their application, and hence it may not be possible for the EDB to disburse the scholarship and means-tested bursary (if any) to them before they commence their study overseas in the {{schYear}} academic year.",
    },

    errorMsg: {
        requiredAgreement:
            "Please check the box to show that you understand and have agreed to the above terms and conditions",
        requiredIamSmart:
            "Please check the box to show that you understand the form can only be signed with iAMSmart+",
        title: 'Please indicate "Mr" or "Miss" or "Ms"',
        maritalStatus:
            'Please indicate "single" or "married/separated/divorced/widowed"',
        selectSame: "Please select a different option",
        information: "Additional information",
        documents: "Relevant supporting document(s)",
        addApplicantRule:
            "Applicant information must be added. Only one parent and spouse can be added at most",
        fax: {
            digit: "Fax number must be exactly 8 digits",
        },
        number: {
            max: "The maximum value for this field is less than {{max}}",
        },
        tel: {
            digit: "This field must be at most {{max}} characters",
        },
        isAssistance:
            "Please choose Yes/No for you or your parents/spouse receive Comprehensive Social Security Assistance",
        isBusiness: "Please choose Yes/No for your parents run any business",
        isAssets:
            "Please choose Yes/No for you or your parents own any other property / land / carpark",
        weI1: 'Please indicate "We" or "I" to declare the information',
        ourMy1: 'Please indicate "our" or "my" family',
        weAndI: 'Please indicate "We are" or "I am" aware that',
        weI2: 'Please indicate "We" or "I" understand The Stealing Ordinance imposes a 10-year prison sentence for fraudulently obtaining financial profit',
        weI3: 'Please indicate "We" or "I" further give',
        ourMy2: 'Please indicate "our" or "my" consent to any department',
        ourMy3: 'Please indicate "our" or "my" personal data to be released to  the SFO',
        yesOrNo: 'Please indicate "Yes" or "No"',
        maritalStu: 'Please indicate "Married" or "Single"',
        workC: 'Please indicate "Full-time" or "Part-time"',
        relationship: "Please indicate Relationship with Applicant",
        colTelNo: "Contact Telephone No.",
        sex: 'Please indicate "Male" or "Female"',
        plc: 'Please indicate "Property" or "Land" or "Carpark"',
    },

    formGuard: {
        title: "Please enter a password",
        submit: "Submit",
        passwordErr: "The password you entered is incorrect. Please try again",
    },
};

export default Form001EN;
